import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbDatepickerConfig,
  NgbDatepickerModule,
  NgbPopover,
  NgbPopoverModule,
  NgbTimepicker,
} from '@ng-bootstrap/ng-bootstrap';
import { DatePipe, CommonModule } from '@angular/common';
import { FoundationModule } from '../../foundation.module';
import { FnDatepRangeConfig } from '../date-range/fn-date-range-config';
import { FNDateTimePickerComponent } from './fn-date-time-picker.component';
import { FnCoreModule } from '../../core';


export * from './fn-date-time-picker.component';
export * from './fn-date-time-picker.model';

/**
 * Provide FnDatepRangeConfig to globally configuration DateRangePicker.
 * And Exports the required FNDateRangePickerComponent to create DateRangePicker Element.
 * making them available for import by NgModules that import this module.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    NgbPopoverModule,
    NgbPopover,
    FoundationModule,
    NgbTimepicker,
    FnCoreModule.forRoot()
  ],
  exports: [FNDateTimePickerComponent],
  declarations: [FNDateTimePickerComponent],
  providers: [
    DatePipe,
    {
      provide: NgbDatepickerConfig,
      useClass: FnDatepRangeConfig,
    },
  ],
})
export class FnDateTimePickerModule { }
